var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m549.98 900c0 54.984-45 99.984-99.984 99.984s-99.984-45-99.984-99.984 45-99.984 99.984-99.984 99.984 45 99.984 99.984zm-99.984-399.98c-54.984 0-99.984 45-99.984 99.984s45 99.984 99.984 99.984 99.984-45 99.984-99.984-45-99.984-99.984-99.984zm0-300c-54.984 0-99.984 45-99.984 99.984s45 99.984 99.984 99.984 99.984-45 99.984-99.984-45-99.984-99.984-99.984zm300 199.97c54.984 0 99.984-45 99.984-99.984s-45-99.984-99.984-99.984-99.984 45-99.984 99.984 45 99.984 99.984 99.984zm0 100.03c-54.984 0-99.984 45-99.984 99.984s45 99.984 99.984 99.984 99.984-45 99.984-99.984-45-99.984-99.984-99.984zm0 300c-54.984 0-99.984 45-99.984 99.984s45 99.984 99.984 99.984 99.984-45 99.984-99.984-45-99.984-99.984-99.984z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.bfddef89b9f7b1fa012683418e6a80db.svg";
export { ForwardRef as ReactComponent };